import React, { useState, useEffect, useMemo } from 'react'
import { useStore } from 'react-redux'
import { Route, Switch, Redirect } from 'react-router-dom'
import Dashboard from './scenes/dashboard'
import Login from './scenes/login'
import Register from './scenes/register'
import Profile from './scenes/profile'
import Team from './scenes/team'
import Teams from './scenes/teams'
import './App.css'

const getUnauthenticatedRoutes = () => {
  return (
    <Switch>
      <Redirect exact from='/' to='/login' />
      <Route path='/login' component={Login} />
      <Route path='/register' component={Register} />
    </Switch>)
}

const getAuthenticatedRoutes = () => {
  return (
    <Switch>
      <Route exact path='/' component={Dashboard} />
      <Route exact path='/profile/:userId' component={({match}) => <Profile userId={match.params.userId} />} />
      <Route exact path='/teams/' component={({match}) => <Teams userId={match.params.userId} />} />
      <Route exact path='/team/:teamId' component={({match}) => <Team teamId={match.params.teamId} />} />
      <Redirect from='/login' to='/' />
    </Switch>
  )
}

export default () => {
  const [authenticated, setAuthenticated] = useState(false)
  const store = useStore()

  const updateState = () => {
    const storeState = store.getState()
    const isAuthenticated = (storeState.cognito && storeState.cognito.authenticated) || false
    setAuthenticated(isAuthenticated)
  }

  useEffect(() => {
    updateState()
    const cleanup = store.subscribe(() => { updateState() })
    return cleanup
  })

  return (
    <div className='scenes-container'>
      { authenticated ? getAuthenticatedRoutes() : getUnauthenticatedRoutes() }
    </div>
  )
}